<template>
  <v-layout style="background: linear-gradient(#7f79d9, #e160df);" class="primary" row fill-height align-center justify-center>
    <v-flex xl5 lg6 md8 sm8 class="ma-5">
      <v-stepper v-model="st" class="ra-2">
        <v-stepper-items>
          <v-stepper-content step="1">
            <v-card text>
              <div class="mx-auto">
                <v-img
                  height="100"
                  contain
                  src="https://cdn.siap.id/s3/masook/asset img/SIM/logo.png"
                  aspect-ratio="1"
                ></v-img>
              </div>
              <v-card-title primary-title>
                <span class="display-1 font-weight-light d-block"
                  >Reset Kata Sandi</span
                >
              </v-card-title>
              <v-card-text>
                <v-form data-vv-scope="form" lazy-validation>
                  <v-layout column wrap>
                    <v-flex>
                      <v-text-field
                        ref="password"
                        type="password"
                        label="Kata Sandi"
                        v-model="password"
                        hint="Kata Sandi"
                        data-vv-name="password"
                        data-vv-as="Kata Sandi"
                        v-validate="'required|min:6'"
                        :error-messages="errors.collect('form.password')"
                      ></v-text-field>
                      <v-text-field
                        type="password"
                        label="Konfirmasi Kata Sandi"
                        v-model="password_confirm"
                        hint="Konfirmasi Kata Sandi"
                        data-vv-name="password_confirm"
                        data-vv-as="Konfirmasi Kata Sandi"
                        v-validate="'required|min:6|confirmed:password'"
                        :error-messages="
                          errors.collect('form.password_confirm')
                        "
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                </v-form>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  depressed
                  :loading="loading"
                  text
                  color="success"
                  @click="resetPassword"
                  >Reset Kata Sandi</v-btn
                >
              </v-card-actions>
            </v-card>
          </v-stepper-content>

          <v-stepper-content step="2">
            <v-card>
              <v-card-text>
                <div class="mx-auto">
                  <v-img
                    height="100"
                    contain
                    src="https://cdn.siap.id/s3/masook/asset img/SIM/logo.png"
                    aspect-ratio="1"
                  ></v-img>
                </div>
                <span class="display-1 font-weight-light d-block"
                  >Reset Kata Sandi berhasil</span
                >
                <p class="mt-3 mb-0">
                  <br />Selanjutnya, Silakan login ke dalam aplikasi dengan cara
                  menekan tombol Masuk di bawah ini
                </p>
              </v-card-text>
              <v-divider></v-divider>
              <v-card-actions>
                <v-layout class="mt-2" justify-end>
                  <v-btn
                    depressed
                    @click="$router.push({ name: 'login' })"
                    text
                    color="success"
                    >Masuk</v-btn
                  >
                  <v-spacer></v-spacer>
                </v-layout>
              </v-card-actions>
            </v-card>
          </v-stepper-content>
        </v-stepper-items>
      </v-stepper>
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  $_veeValidate: {
    validator: "new"
  },
  components: {},
  data() {
    return {
      st: 1,
      token: null,
      password: null,
      password_confirm: null,
      loading: false
    };
  },
  mounted() {},
  methods: {
    resetPassword() {
      this.$validator
        .validateAll("form")
        .then(res => {
          if (!res) return Promise.reject();
        })
        .then(() => {
          this.loading = true;
          this.token = this.$route.query.token;
          this.$store
            .dispatch("user/resetPassword", {
              token: this.token,
              password: this.password,
              password_confirm: this.password_confirm,
              kode_organisasi: this.organisasi_id || '',
            })
            .then(() => {
              this.loading = false;
              this.st++;
            })
            .catch(() => {
              this.loading = false;
            });
        })
        .catch(e => e);
    }
  }
};
</script>
